import React from 'react';
import { reduxForm, Field, stopSubmit } from 'redux-form';
import { TextField, Button } from 'components/index';
import { FormTile } from 'components/FormTile';
import { validate } from './validate';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
class MfaCodeFormComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleResendCode = async () => {
            this.props.reset();
            this.props.clearSubmit();
            const response = await this.props.onResendCode();
            if ((response === null || response === void 0 ? void 0 : response.code) !== 'success') {
                this.props.dispatch(stopSubmit(this.props.form, getReduxFormError(response)));
            }
        };
    }
    render() {
        const { handleSubmit, error, submitFailed, isFormProcessed, onBackToLogin, } = this.props;
        return (React.createElement("form", { onSubmit: handleSubmit, className: "form-tile-with-image " },
            React.createElement(FormTile, { isLoaderShow: isFormProcessed },
                React.createElement(FormTile.Header, null,
                    React.createElement("div", { className: "form-description-logo" },
                        React.createElement("img", { className: "form-description-logo__img", src: "/assets/images/logo/description-logo@2x.png", alt: "Anova logo" }))),
                React.createElement(FormTile.Body, null,
                    React.createElement("h2", { className: "mt-25" }, "Confirmation Code"),
                    React.createElement("div", { className: "mt-1 form-fields__description" }, "To ensure your account security, Multi-Factor Authentication (MFA) via email verification is required. We have sent a unique verification code to your registered email address."),
                    React.createElement(Field, { label: "Code:", name: "code", component: TextField, type: "text", maxLength: 6, isBackgroundErrorDisplay: false, fieldClassName: "mt-14" }),
                    React.createElement("div", { className: "mt-10 sign-up-form__terms" },
                        React.createElement(Button, { onClick: this.handleResendCode, className: "_simple-red", type: "button" }, "Resend Verification Code"))),
                React.createElement(FormTile.Footer, null,
                    error && submitFailed && (React.createElement("div", { className: "form-tile-footer__error" }, error)),
                    React.createElement("div", { className: "form-tile-footer__panel" },
                        React.createElement(Button, { onClick: onBackToLogin, className: "_simple-red", type: "button" }, "Back to Login Form"),
                        React.createElement(Button, { className: "_red", type: "submit" }, "Submit"))))));
    }
}
export const MfaCodeForm = reduxForm({
    form: 'mfaCodeForm',
    validate,
})(MfaCodeFormComponent);
